// angular.module('raSpinner')
// .directive('raSpinner',

/* @ngInject */
export default function SpinnerDirective() {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            name: '@?',
            group: '@?',
            show: '=?',
            hideContentWhenShown: '=?',
            imgSrc: '@?',
            register: '@?',
            onLoaded: '&?',
            onShow: '&?',
            onHide: '&?',
            template: '@?',
            text: '@?',
        },

        templateUrl(element, attr) {
            const templateName = attr.template || 'defaultSpinnerTemplate';
            return `app/common/spinner/template/${templateName}.html`;
        },

        controller: 'SpinnerController',
    };
}



// WEBPACK FOOTER //
// ./src/app/common/spinner/spinnerDirective.js